import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../media-query';
import UserMenu from './user/menu';
import NavbarMobile from './nav/bar-mobile';
import NavbarFull from './nav/bar-full';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.width >= 900 && this.state.width < 900) {
            this.toggle();
            return true;
        }

        if (nextState.width < 900 && this.state.width >= 900) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        return false;
    }

    render() {
        if (MQ.isMobile() || MQ.isTabletPortrait()) {
            return (
                <top-bar noads={this.props.noads} className={this.props.class}>
                    <div className='tarot-top-bar-mobile'>
                        {this.renderPromoMessage()}
                        <a href='/' onClick={() => this.trackEvent('Navigation', 'Tarot.com Logo')}>
                            {this.renderImg()}
                        </a>
                        <a className='toggle-menu' onClick={this.toggle} ref={(el) => this.toggleMenu = el}>
                            <div className='icon'>
                                <span />
                                <span />
                                <span />
                                <span />
                            </div>
                        </a>
                    </div>
                    <nav onClick={this.handleClick}>
                        {this.renderNav()}
                    </nav>
                </top-bar>
            );
        }

        return (
            <top-bar noads={this.props.noads} className={this.props.class}>
                <nav>
                    <a href='/' onClick={() => this.trackEvent('Navigation', 'Tarot.com Logo')}>
                        {this.renderImg()}
                    </a>
                    {this.renderNav()}
                    <UserMenu />
                </nav>
            </top-bar>
        );
    }

    renderPromoMessage = () => {
        // Changed from imported child component to raw jsx because topbar promo was duplicating mounts
        if (!this.props.noads) {
            return (<promo-message placement='topbar' tags='general' />);
        }

        if (this.props.pmp) {
            return (<promo-message-preview placement='topbar' />);
        }

        return null;

    }

    renderImg = () => {
        const img_src = this.props.code
            ? `https://gfx.tarot.com/images/holiday-campaigns/${this.props.code}/mobile_logo.svg`
            : 'https://gfx.tarot.com/images/site/logo/logo.svg';

        return (<img className='top-bar-logo' src={img_src} alt='Tarot.com' />);
    }

    renderNav = () => {
        if (MQ.isMobile() || MQ.isTabletPortrait()) {
            return (<NavbarMobile />);
        } else if (this.props.class.match(/showFullNav/) && this.state.width >= 900) {
            return (<NavbarFull />);
        }

        return (<nav-bar />);
    }

    toggle = () => {
        const isOpen = this.toggleMenu && this.toggleMenu.classList && this.toggleMenu.classList.contains('open');
        const dfp_ad = document.querySelector('dfp[name="Top"]');
        const misc_elements = document.querySelectorAll('body, header nav, dfp[name="Top"], main, footer, top-bar');
        const [action, label] = isOpen ? ['Close', 'X'] : ['Open', 'Hamburger'];

        this.props.trackEvent(['Navigation', action, label]);

        if (dfp_ad && dfp_ad.length) {
            if (isOpen) {
                dfp_ad.style.display = 'block';
                dfp_ad.style.height = 'auto';
            } else {
                dfp_ad.style.display = 'none';
                dfp_ad.style.height = 0;
            }
        }

        if (window.innerWidth >= 900) {
            this.closeNav(misc_elements);
        } else if (!isOpen) {
            if (this.toggleMenu.classList) {
                this.toggleMenu.classList.add('open');
            }

            misc_elements.forEach((el) => {
                if (el.classList) {
                    el.classList.add('show-nav');
                }
            });
        } else {
            this.closeNav(misc_elements);
        }
    }

    closeNav = (misc_elements) => {
        misc_elements.forEach((el) => {
            if (el.classList) {
                el.classList.remove('show-nav');
            }
        });

        if (this.toggleMenu && this.toggleMenu.classList) {
            this.toggleMenu.classList.remove('open');
        }
    }

    trackEvent = (category, label) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent([category, action, label]);
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }

    handleClick = (e) => {
        if (e.target.localName == 'nav') {
            this.toggle();
        }
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    pmp: state['promo-message-preview'],
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
